import { AnimateActionButton } from 'components/content/memory/memoryToolBar/AnimateActionButton'
import { SAnimateContainer } from './MemoryToolBar.styled'
import { Icon } from 'components/icon'
import { useTranslation } from 'next-i18next'
import { useWindowSize } from 'utils/hooks'

export function AnimateActions(props: {
  isSingingPortrait: boolean
  inDropdown: boolean
  singingPortraitAction?: () => void
  livingPortraitAction?: () => void
}) {
  const { t } = useTranslation('life_stories')
  const { isDesktop } = useWindowSize()

  const hideTitle = !isDesktop && !props.inDropdown

  return (
    <SAnimateContainer inDropdown={props.inDropdown}>
      {!!props.singingPortraitAction && (
        <AnimateActionButton
          hideTitle={hideTitle}
          title={
            props.isSingingPortrait
              ? t('life_stories.inside_page.animate_actions.singing_portrait_title_change')
              : t('life_stories.inside_page.animate_actions.singing_portrait_title_create')
          }
          onClick={props.singingPortraitAction}
          hasNewTag={isDesktop}
          icon={<Icon name="SelectSong" />}
        />
      )}

      {!!props.livingPortraitAction && (
        <AnimateActionButton
          hideTitle={hideTitle}
          onClick={props.livingPortraitAction}
          title={
            isDesktop
              ? t('life_stories.inside_page.animate_actions.living_portrait_title_desktop')
              : t('life_stories.inside_page.animate_actions.living_portrait_title_mobile')
          }
          icon={<Icon name="Wand" />}
        />
      )}
    </SAnimateContainer>
  )
}
